import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal } from 'react-icons/fi';
import { Dropdown } from 'react-bootstrap';
import ShiftCard from 'components/Shifts/ShiftCard';
import ShiftEditModal from 'components/Shifts/ShiftEditModal';
import { showModal, hideModal } from 'actions/modalActions';
import * as shiftsActions from 'actions/shiftsActions';
import { shiftsService } from 'services';
import { errorFormating } from 'utils/utils';
import { convertFromUTC } from 'utils/datetime';
import { withTranslation } from 'react-i18next';
// import moment from 'moment';
class ShiftList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openEditShiftModal = this.openEditShiftModal.bind(this);
		this.openDeleteShiftModal = this.openDeleteShiftModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditShiftModal(shift) {
		const { getShifts } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t('shifts.editShift'),
				style: { width: '640px', maxHeight: '90vh' },
				content: (
					<ShiftEditModal
						shift={shift}
						getShifts={getShifts}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	openDeleteShiftModal(idShift) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('shifts.deleteShift'),
				style: { width: '400px' },
				message: this.props.t('shifts.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idShift),
				closeModal: this.closeModal,
			},
			'delete'
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('shifts.deleteError'),
				style: { width: '400px' },
				message: message,
				closeModal: this.closeModal,
			},
			'alert'
		);
	}

	confirmDelete = async (idShift) => {
		const response = await shiftsService.remove(idShift);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.props.getShifts();

			this.closeModal();
		}
	};

	getEmptyRow = () => {
		return <p>{this.props.t("common.noResults")}</p>;
	};

	orderDayTypes = (shift_day_types) => {
		// console.log(shift_day_types);
		return shift_day_types.sort(function (a, b) {
			// fix para poner festivos al final
			if (!a.weekday) a.weekday = 8;
			if (!b.weekday) b.weekday = 8;

			return a.weekday - b.weekday;
		});
	};

	/** A partir de "HH:mm" local: hora entera → solo h (1–23); con minutos → HH:mm */
	formatShiftClockLabel = (hhmm) => {
		if (!hhmm) return '';
		const [hStr, mStr] = hhmm.split(':');
		const h = parseInt(hStr, 10);
		const m = parseInt(mStr || '0', 10);
		if (Number.isNaN(h)) return hhmm;
		if (m === 0) return String(h);
		const hh = String(h).padStart(2, '0');
		const mm = String(m).padStart(2, '0');
		return `${hh}:${mm}`;
	};

	getPeriodsLabel = (time_intervals) => {
		if (!time_intervals || time_intervals.length === 0) return '';
		return time_intervals
			.map((item) => {
				const start = this.formatShiftClockLabel(convertFromUTC(item.start));
				const end = this.formatShiftClockLabel(convertFromUTC(item.end));
				return `${start}-${end}h`;
			})
			.join(' — ');
	};

	getDayTypesLabel = (type_list) =>
		type_list.map((item) => item.name).join(', ');

	getRows = () =>
		this.props.shifts.map((shift) => {
			const shift_day_types = this.orderDayTypes(shift.day_types);
			const periodsLabel = this.getPeriodsLabel(shift.time_intervals);
			const dayTypesLabel =
				this.getDayTypesLabel(shift_day_types) || '—';

			return (
				<div className="col-sm-6 col-xl-4 col-xxl-3" key={shift.id}>
					<ShiftCard
						name={shift.name}
						periodsLabel={periodsLabel}
						dayTypesLabel={dayTypesLabel}
						shiftType={shift.type || '—'}
						color={shift.background_color}
						description={shift.description}
						onCardClick={() => this.openEditShiftModal(shift)}
						headerActions={
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.openEditShiftModal(shift)}
									>
										{this.props.t("common.edit")}
									</Dropdown.Item>
									{!shift.system && (
										<Dropdown.Item
											as="button"
											onClick={() => this.openDeleteShiftModal(shift.id)}
										>
											{this.props.t("common.delete")}
										</Dropdown.Item>
									)}
								</Dropdown.Menu>
							</Dropdown>
						}
					/>
				</div>
			);
		});

	render() {
		return (
			<>
				{this.props.shifts.length === 0 ? (
					this.getEmptyRow()
				) : (
					<div className="row list-shifts">{this.getRows()}</div>
				)}
			</>
		);
	}
}

const mapStateToProps = (reducers, ownProps) => ({
	...reducers.shiftsReducer,
	shifts: ownProps.shifts ?? reducers.shiftsReducer.shifts,
});

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShiftList));
